import { useEffect, useState } from "react";

/** Seconds since `startedAt` (an ISO time), updated every second; never negative, even with a skewed clock. */
export function useSecondsSince(startedAt: string) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);
  const start = Date.parse(startedAt);
  return Number.isNaN(start) ? 0 : Math.max(0, (now - start) / 1000);
}
